import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProgramResolve } from '@program/program-resolve.model';
import { ProgramApplication } from '@program/shared/program-application.model';
import { ProgramApplicationService } from '@program/shared/program-application.service';
import { Program } from '@program/shared/program.model';
import { DOCUMENT_TAG_TYPE } from '@shared/components/files/shared/document-tag-type.enum';
import { FilesActions } from '@shared/components/files/shared/models/action.model';
import { TagType } from '@shared/components/files/shared/models/tag-type.model';
import { ROLE_TYPE } from '@user/role-type';
import { User } from '@user/user.model';
import { UserService } from '@user/user.service';
import { take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'oes-program-message-developer',
  templateUrl: './message-developer.component.html',
  styleUrls: ['./message-developer.component.scss']
})
export class ProgramMessageDeveloperComponent implements OnInit {
  @Input() program: Program;

  programApplication: ProgramApplication;
  tabs = {
    messages: true,
    files: false
  };
  tagTypes: TagType[];
  user: User;

  private currentRole: ROLE_TYPE;

  constructor(private _activatedRoute: ActivatedRoute,
              private _programApplicationService: ProgramApplicationService,
              private _userService: UserService) {
  }

  ngOnInit(): void {
    if (!this.program) {
      this._activatedRoute.parent.data
      .pipe(take(1))
      .subscribe((data: { result: ProgramResolve }) => {
        this.currentRole = this._userService.getSelectedRole();
        this.program = data?.result?.program;
        this.getProgramApplication();
        this.user = data?.result?.user;
      });
    } else {
      this._userService.getCurrentUser()
      .pipe(take(1))
      .subscribe((user: User) => {
        this.user = user;
        this.currentRole = this._userService.getSelectedRole();
        this.getProgramApplication();
      });
    }
  }

  getProgramApplication() {
    if (this.program && this.program.id) {
      this._programApplicationService.findProgramApplications(this.program.id)
      .pipe(take(1))
      .subscribe((programApplications: ProgramApplication[]) => {
        if (programApplications && programApplications.length > 0) {
          // Select the lowest stage rank (stage-0) application so the tag we write/read matches
          // the stage-0 application the program owner queries. Sort explicitly rather than relying
          // on the endpoint's ordering; missing stage configurations sort first (treated as rank 0).
          this.programApplication = [...programApplications].sort(
            (a, b) => (a?.programApplicationStageConfiguration?.stageRank ?? 0)
                    - (b?.programApplicationStageConfiguration?.stageRank ?? 0)
          )[0];
          this.setTagTypes();
        }
      });
    }
  }

  private setTagTypes() {
    this.tagTypes = [{
      docTagItemId: this.programApplication?.id,//applicationId,
      docTagType: DOCUMENT_TAG_TYPE.PROGRAM_PARTICIPANT_MESSAGES,
      name: this.user?.organization?.name
    }];
  }

  get accessControl (): any {
    if (this.currentRole === ROLE_TYPE.DEVELOPER_USER) {
      return new FilesActions({
        download: true,
        preview: true
      });
    }
    return new FilesActions({});
  }
}
